import About from "../About";

function AboutPage() {
    return(<>
        <About />
    </>)
}

export default AboutPage;